import ReactGA from 'react-ga'

ReactGA.initialize('UA-123958129-1')
